// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__7tK4g","content":"Header_content__CAGYn","user":"Header_user__AZZei"};